"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomSlider = void 0;
exports.CustomSliderThumb = CustomSliderThumb;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CustomSlider = (0, _core.withStyles)({
  root: {
    color: '#3a8589',
    height: 3,
    padding: '13px 0',
    paddingTop: 19
  },
  thumb: {
    height: 27,
    width: 27,
    backgroundColor: '#fff',
    border: '1px solid currentColor',
    marginTop: -12,
    marginLeft: -13,
    boxShadow: '#ebebeb 0 2px 2px',
    '&:focus, &:hover, &$active': {
      boxShadow: '#ccc 0 2px 3px 1px'
    },
    '& .bar': {
      height: 9,
      width: 1,
      backgroundColor: 'currentColor',
      marginLeft: 1,
      marginRight: 1
    }
  },
  active: {},
  track: {
    height: 3
  },
  rail: {
    color: '#d8d8d8',
    opacity: 1,
    height: 3
  }
})(_core.Slider);
exports.CustomSlider = CustomSlider;
function CustomSliderThumb(props) {
  return /*#__PURE__*/_react.default.createElement("span", props, /*#__PURE__*/_react.default.createElement("span", {
    className: "bar"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "bar"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "bar"
  }));
}